<script>
  import TextButton from '../../../components/TextButton.svelte'
  import Letterchar from '../../../components/ReviewerProfile/Letterchar.svelte'
  import Content from '../Content.svelte'

  export let comments = []
  export let reviewerName
  export let profilePictureColor
  export let textColor
  export let commentsId
  export let currentId
  export let loadComments
  export let remainingComments
  export let nameColor
  export let isQna = false
  export let textDirection
  export let buttonTextColor
  export let readMoreText
  export let readMoreTextColor
  export let readLessText
</script>

<style>
  .answer-list {
    margin-bottom: 30px;
  }

  .load-more-box {
    text-align: center;
    margin: 20px 0;
  }

  .answer {
    margin: 13px 0 13px 24px;
  }

  .answer-box {
    display: flex !important;
    align-items: flex-start;
  }

  .profile {
    display: flex !important;
    align-items: center;
  }

  p {
    display: block;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
  }

  .name {
    color: #1528d0;
    font-weight: 600;
    margin-bottom: 4px;
  }

  .hidden {
    display: none;
  }
</style>

<div
  class="$style.answer-list"
  class:hidden={commentsId !== currentId}
  id={commentsId}>
  {#if remainingComments && remainingComments.length > 0}
    <div class="$style.load-more-box">
      <TextButton textColor={buttonTextColor} handleClick={loadComments}>
        View more {isQna ? 'answers' : 'comments'}
      </TextButton>
    </div>
  {/if}
  {#each comments as comment}
    <div class="$style.answer">
      <div class="$style.answer-box">
        <div class="$style.profile">
          <div class="$style.avatar small">
            <Letterchar
              defaultSize="33px"
              {profilePictureColor}
              {reviewerName} />
          </div>
        </div>
        <div class="$style.content">
          <p>
            <span class="$style.name" style="color: {nameColor};">
              {reviewerName}
            </span>
          </p>
          <Content
            class="$style.content"
            message={comment.text}
            {textDirection}
            {isQna}
            {readLessText}
            {readMoreText}
            {readMoreTextColor}
            isAnswers={true}
            color={textColor} />
        </div>
      </div>
    </div>
  {/each}
</div>
